module.exports = __webpack_public_path__ + "img/ideas.51bcb5c2.png";